export default __webpack_public_path__ + "static/media/Rupashi.a7ecf49f.jpg";